import React, { Component } from 'react';
import { Breadcrumb, Button, Container, Header,Grid, Menu, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { translate } from 'react-i18next';
import update from 'immutability-helper';
import * as Routes from '../../../routes';
import SimpleList from '../../lists/SimpleList';
import SubNavigationBar from '../../navigation/SubNavigationBar';
import { AutoSizer } from 'react-virtualized';
import moment from 'moment';
import numeral from 'numeral';

const INITIAL_STATE = {
  saldo: {
    loading: false,
    data: 0,
    error: null
  }
};

class DashboardView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.TransactionService = props.services.feathers.service('api/transactions');
    this.ReservationService = props.services.feathers.service('api/reservations');
    this.SaldoService = props.services.feathers.service('api/saldo');
  }

  static mapDispatchToProps (dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path))
    };
  }

  static mapStateToProps (state) {
    return {
      authentication: state.authentication.toJS()
    };
  }

  getSaldo = () => {
    let { authentication } = this.props;

    this.setState(update(this.state, {
      saldo: {
        $merge: {
          loading: true,
          data: 'Cargando...'
        }
      }
    }));

    if (!authentication.user) {
      return;
    }
    this.SaldoService.get(authentication.user.SocioId)
      .then(response => {
        console.log(response);
        this.setState(update(this.state, {
          saldo: {
            $merge: {
              loading: false,
              data: numeral(response.monto).format('$0,0.00')
            }
          }
        }));
      })
      .catch(error => {
        this.setState(update(this.state, {
          saldo: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  componentDidMount () {
    this.getSaldo();
  }

  render () {
    const { t, authentication } = this.props;
    let { saldo } = this.state;
    const userRoles = authentication && authentication.user && authentication.user.roles
      ? authentication.user.roles
      : [];

    return (
      <AutoSizer disableHeight style={{ display: 'flex', flex: 1 }}>
        {
          ({ width }) => {
            let Wrapper = Container;
            let style = {};

            if (width < 764) {
              Wrapper = 'div';
              style = {
                margin: 0,
                width
              };
            }

            return (
              <Wrapper style={style}>
                {
                  width >= 764 && <SubNavigationBar activeLink="inicio" roles={userRoles} />
                }

                <Segment vertical secondary style={{ padding: 4 }}>
                  <Breadcrumb>
                    <Breadcrumb.Section as={Link} link to={'/dashboard'}>Inicio</Breadcrumb.Section>
                    <Breadcrumb.Divider icon="right angle" />
                    <Breadcrumb.Section active>Principal</Breadcrumb.Section>
                  </Breadcrumb>
                </Segment>

                <Segment vertical>
                  <Header as="h3">
                    <Header.Content>
                      {(authentication.user && authentication.user.fullName) || ''}
                      <Header.Subheader>
                        Informacion general
                      </Header.Subheader>
                    </Header.Content>
                  </Header>
                </Segment>

                <Segment vertical>
                  <Button as={Link} basic content="RESERVAR" fluid primary size="large" to={Routes.RESERVATION_NEW} />
                </Segment>

                <Segment vertical>
                  <Grid columns={2} doubling>
                    <Grid.Column>
                      <SimpleList
                        header="Mis Saldo" subheader="Transacciones"
                        service={this.TransactionService}
                        findParams={{
                          query: { SocioId: authentication.user.SocioId, $limit: 5 }
                        }}
                        mappingFunc={(transaction) => ({
                          header: transaction.concepto,
                          description: moment(transaction.fecha).parseZone().format('DD/MM/YYYY HH:mm'),
                          icon: transaction.monto > 0 ? 'circle add' : 'circle minus',
                          iconColor: transaction.monto > 0 ? 'green' : 'red',
                          floatedContent: numeral(transaction.monto).format('$0,0.00'),
                          floatedContentColor: transaction.monto > 0 ? 'green' : 'red'
                        })}
                        headerButton={{
                          content: 'Cargar saldo',
                          icon: 'add',
                          to: '/balance/addfunds'
                        }}
                        statisticValue={saldo.data}
                        statisticLabel="Balance"
                        expandLink="/balance" />
                    </Grid.Column>
                    <Grid.Column>
                      <SimpleList
                        header="Mis Reservas" subheader="Reservas pendientes y realizadas"
                        service={this.ReservationService}
                        findParams={{
                          query: { SocioId: authentication.user.SocioId, $limit: 5 }
                        }}
                        mappingFunc={(reservation) => ({
                          header: `${reservation.concepto}`,
                          description: `Court ${reservation.cancha} - ` + moment(reservation.fecha).parseZone().format('DD/MM/YYYY HH:mm'),
                          icon: moment(reservation.fecha).parseZone().isBefore(moment()) ? 'check circle' : 'radio',
                          iconColor: moment(reservation.fecha).parseZone().isBefore(moment()) ? 'green' : 'black'
                        })}
                        expandLink="/reservations" />
                    </Grid.Column>
                  </Grid>
                </Segment>
              </Wrapper>
            );
          }
        }
      </AutoSizer>
    );
  }

}

const i18nEnhancement = translate('translations')(DashboardView);

export default connect(DashboardView.mapStateToProps, DashboardView.mapDispatchToProps)(i18nEnhancement);


// WEBPACK FOOTER //
// ./src/components/views/dashboard/DashboardView.jsx